import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-stripe-dialog-wrapper',
    templateUrl: './stripe-dialog-wrapper.component.html',
    styleUrls: ['./stripe-dialog-wrapper.component.scss']
})
export class StripeDialogWrapperComponent {
    constructor(
        public dialogRef: MatDialogRef<StripeDialogWrapperComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }
}
